module.exports = __webpack_public_path__ + "static/avatar-50d9db8ee413f0a7d9775b48291533c6.png";